import { Button, Stack } from '@chakra-ui/react';
import React from 'react';
import { PhoneIcon } from '@chakra-ui/icons';
import { LineEventTypes, sendLineTagEvent } from '@/utils/sendLineTagEvent';
import Link from 'next/link';
import clsx from 'clsx';

export const ContactFooter: React.FC<{ className?: string; sid: string }> = ({ sid }) => {
  const onCallClick = () => sendLineTagEvent(`${LineEventTypes.phone_call}_${sid}`);

  return (
    <React.Fragment>
      <div className={clsx('h-[4.5rem]', 'sm:hidden sm:invisible')} />
      <Stack
        w={'100vw'}
        position={'fixed'}
        px={4}
        justify={'space-between'}
        bottom={0}
        insetX={0}
        py={3}
        bg={'white'}
        zIndex={52}
        direction={'row'}
        display={{
          base: 'flex',
          sm: 'none',
        }}
        visibility={{
          sm: 'hidden',
        }}
      >
        <div className={clsx('flex-1')}>
          <Button
            as={'a'}
            href={`tel:${process.env.NEXT_PUBLIC_FUNWOO_TAIWAN_CELLPHONE}`}
            leftIcon={<PhoneIcon />}
            w={'full'}
            h={12}
            onClick={onCallClick}
          >
            立即諮詢
          </Button>
        </div>

        <div className={clsx('flex-1')}>
          <Link href={'/contact'} passHref>
            <Button as={'a'} variant={'secondary'} w={'full'} h={12}>
              專人回電
            </Button>
          </Link>
        </div>
      </Stack>
    </React.Fragment>
  );
};
